module.exports = __webpack_public_path__ + "img/music_020.3283c408.png";